import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(62)}
    height={scaleSize(40)}
    viewBox="0 0 62 40"
  >
    <g fill="#FFF" fillRule="evenodd">
      <path d="M3.08.325l28.015 17.992a2 2 0 0 1 0 3.366L3.081 39.674A2 2 0 0 1 0 37.992V2.008A2 2 0 0 1 3.08.325z" />
      <path d="M33.08.325l28.015 17.992a2 2 0 0 1 0 3.366L33.081 39.674A2 2 0 0 1 30 37.992V2.008A2 2 0 0 1 33.08.325z" />
    </g>
  </svg>
);
